import React from 'react';
import { connect } from 'react-redux';
import { Modal, Row, Col, Spin, Form} from 'antd';

import { Select, Input } from 'antd';
import { actions, asyncUpdate, asyncAdd, asyncGet } from './reducers';
import { formItemLayout, formatFormData } from './utils';
const FormItem = Form.Item;
const { TextArea } = Input;

class Edit extends React.Component {
    handleCancel = () => {
        this.props.form.resetFields();
        this.props.modalHide();
        this.props.changeCurrentSelectId();
    };
    handleOk = () => {
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                for (let i in values) {
                    if (!values[i]) {
                        delete values[i];
                    }
                }
                if (this.props.item.advertId === undefined) {
                    await this.props.asyncAdd(formatFormData(values));
                } else {
                    await this.props.asyncUpdate(formatFormData(values));
                }
                this.props.form.resetFields();
                this.props.modalHide();
                this.props.changeCurrentSelectId();
                this.props.asyncGet();
            } else {
                console.log(err);
            }
        });
    };

    render() {
        const { isModalShow, isLoading, item } = this.props;
        const { getFieldDecorator } = this.props.form;
        const form = (
            <Form>
                <Row>
                <Col span={24}>
                        <FormItem {...formItemLayout} label="">
                            {getFieldDecorator('deleteFlag', {
                                initialValue: item.deleteFlag || '0',
                                rules: [
                                    {
                                        required: false,
                                        message: '请输入 ',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" type="hidden" style={{ width: '100%' }} disabled />,
                            )}
                        </FormItem>
                    </Col>
                    <Col span={24}>
                        <FormItem {...formItemLayout} label="advertId">
                            {getFieldDecorator('advertId', {
                                initialValue: item.advertId || '0',
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入 ',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }} disabled />,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="taskId">
                            {getFieldDecorator('taskId', {
                                initialValue: item.taskId || '',
                                rules: [
                                    {
                                        required: false,
                                        message: '请输入 ',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }} />,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="app">
                            {getFieldDecorator('app', {
                                initialValue: item.app || '',
                                rules: [
                                    {
                                        required: false,
                                        message: '请输入 ',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }} />,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="广告平台">
                            {getFieldDecorator('adPlatform', {
                                initialValue: item.adPlatform || '',
                                rules: [
                                    {
                                        required: false,
                                        message: '请选择',
                                    },
                                ],
                            })(
                                <Select style={{ width: '100%' }} placeholder="请选择">
                                    <Option value="广点通">广点通</Option>
                                    <Option value="穿山甲">穿山甲</Option>
                                </Select>,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="接入方式">
                            {getFieldDecorator('joinWay', {
                                initialValue: item.joinWay || '',
                                rules: [
                                    {
                                        required: false,
                                        message: '请选择',
                                    },
                                ],
                            })(
                                <Select style={{ width: '100%' }} placeholder="请选择">
                                    <Option value="SDK">SDK</Option>
                                    <Option value="API">API</Option>
                                </Select>,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="手机系统">
                            {getFieldDecorator('phoneSystem', {
                                initialValue: item.phoneSystem || '',
                                rules: [
                                    {
                                        required: false,
                                        message: '请选择',
                                    },
                                ],
                            })(
                                <Select style={{ width: '100%' }} placeholder="请选择">
                                    <Option value="Android">Android</Option>
                                    <Option value="IOS">IOS</Option>
                                </Select>,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="广告位">
                            {getFieldDecorator('adPosition', {
                                initialValue: item.adPosition || '',
                                rules: [
                                    {
                                        required: false,
                                        message: '请选择',
                                    },
                                ],
                            })(
                                <Select style={{ width: '100%' }} placeholder="请选择">
                                    <Option value="信息流">信息流</Option>
                                    <Option value="开屏">开屏</Option>
                                    <Option value="banner">banner</Option>
                                </Select>,
                            )}
                        </FormItem>
                    </Col>

                </Row>
            </Form>
        );

        return (
            <span>
                <Modal
                    width={800}
                    title="修改"
                    visible={isModalShow}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    confirmLoading={isLoading}
                    maskClosable={false}
                    okText="确定"
                    cancelText="取消">
                    <Spin spinning={isLoading} tip="保存中...">
                        {form}
                    </Spin>
                </Modal>
            </span>
        );
    }
}

const mapStateToProps = state => ({
    item: state.advertPosition.list.reduce((a, b) => (b.advertId === state.advertPosition.currentSelectId ? b : a), {}),
    isModalShow: state.advertPosition.uiStatus.isUpdateShow,
    isLoading: state.advertPosition.uiStatus.isLoading,
});

const mapDispatchToProps = dispatch => ({
    modalHide: () => dispatch(actions.changeUiStatus({ isUpdateShow: false })),
    asyncUpdate: contents => dispatch(asyncUpdate(contents)),
    asyncAdd: contents => dispatch(asyncAdd(contents)),
    asyncGet: () => dispatch(asyncGet()),
    changeCurrentSelectId: () => dispatch(actions.changeCurrentSelectId('')),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(Edit));



// WEBPACK FOOTER //
// ./pages/client/advertPosition/edit.js